import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FONT_GSS_FUTURA } from '@monorepo/shared/src/themes/studentAppTheme';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import MatMan from 'components/common/Tour/MatMan';

type Props = {
  text: string;
  imageClass?: any;
  bannerClass: any;
};
const MessageCallOutBanner: React.FC<Props> = ({ text, imageClass, bannerClass }) => {
  const classes = useStyles();

  return (
    <Box>
      {imageClass && <MatMan imageClass={imageClass} />}

      <Typography className={`${classes.text} ${bannerClass}`}>
        <span dangerouslySetInnerHTML={{ __html: text }} />
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  text: {
    width: '456px',
    borderRadius: '24px',
    background: 'linear-gradient(129.63deg, #0094DF 0%, #005BBB 100%)',
    color: '#FFFFFF',
    fontFamily: FONT_GSS_FUTURA,
    fontSize: '32px',
    fontWeight: 600,
    letterSpacing: 0,
    lineHeight: '48px',
    padding: remCalc(40),
    '& hr': {
      flexBasis: '100%',
      height: 0,
      margin: 8,
      border: 0,
    },
    [`${theme.breakpoints.down('md')}`]: {
      padding: remCalc(20),
      fontSize: '24px',
      lineHeight: '30px',
      width: '356px',
    },
  },
}));

export default MessageCallOutBanner;
